/**
 * Created by User on 11.06.2017.
 */
export class DropdownSearchListItem {
  constructor(public id: number = null, public title: string = '') {}
}
